import { useCallback } from 'react';

import useDefaultErrorSnackbar from '@/hooks/useDefaultErrorSnackbar';
import { ResourceStatusEnum } from '@/types/schema';

import { useUpdateContentStatusMutation } from '../../graphql/mutations/generated/updateContentStatus';

const useUpdateContentStatus = () => {
  const [{ fetching }, updateContentStatus] = useUpdateContentStatusMutation();
  const { showDefaultErrorSnackbar } = useDefaultErrorSnackbar();

  const onUpdateContentStatus = useCallback(
    async (id: string, status: ResourceStatusEnum) => {
      const res = await updateContentStatus({ input: { id, status } });

      if (!res || res.error) {
        showDefaultErrorSnackbar();
      }
      return res;
    },
    [showDefaultErrorSnackbar, updateContentStatus],
  );

  return { fetching, onUpdateContentStatus };
};

export default useUpdateContentStatus;
